import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const AuthCallback = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Get all query parameters from the current URL
    // searchParams is already a URLSearchParams object, so we can use it directly
    const queryString = searchParams.toString();
    
    // Build the rork-app:// URL with all parameters
    const rorkAppUrl = queryString 
      ? `rork-app://?${queryString}`
      : 'rork-app://';
    
    // Redirect to the rork-app:// URL
    window.location.href = rorkAppUrl;
  }, [searchParams]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column',
      gap: '1rem'
    }}>
      <p>Redirecting to app...</p>
    </div>
  );
};

export default AuthCallback;

